module.exports = __webpack_public_path__ + "media/fonts/lineto-circular-book-c541f8e1.eot";